import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qc-type-grid',
  templateUrl: './qc-type-grid.component.html',
  styleUrls: ['./qc-type-grid.component.css']
})
export class QcTypeGridComponent implements OnInit {

  title="Quality Control Test Types";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technical/qc-type/qc-type-grid/qc-type-grid.component.ts